<div
  class="legal-overlay"
  *ngIf="currentDoc"
  (click)="close()"
>
  <div
    class="legal-modal"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="currentDoc.title"
    (click)="$event.stopPropagation()"
  >

    <!-- HEADER -->
    <div class="legal-modal-header">
      <div class="legal-modal-heading">
        <h2>{{ currentDoc.title }}</h2>
        <span class="legal-modal-date">Effective {{ currentDoc.effectiveDate }}</span>
      </div>

      <button
        class="legal-modal-close"
        type="button"
        aria-label="Close"
        (click)="close()"
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M1 1L17 17M17 1L1 17" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <!-- BODY -->
    <div class="legal-modal-body">
      <section
        class="legal-section"
        *ngFor="let section of currentDoc.sections"
      >
        <h3 *ngIf="section.heading">{{ section.heading }}</h3>

        <p *ngFor="let p of section.paragraphs">{{ p }}</p>

        <ul *ngIf="section.list">
          <li *ngFor="let item of section.list">{{ item }}</li>
        </ul>
      </section>
    </div>

    <!-- FOOTER: switch between the three docs -->
    <div class="legal-modal-footer">
        <button
        type="button"
        class="legal-switch"
        [class.active]="activeDoc === 'cookies'"
        (click)="switchTo('cookies')"
      >
        Cookie Policy
      </button>
      

      <button
        type="button"
        class="legal-switch"
        [class.active]="activeDoc === 'terms'"
        (click)="switchTo('terms')"
      >
        Legal Notice &amp; Terms
      </button>

      <button
        type="button"
        class="legal-switch"
        [class.active]="activeDoc === 'privacy'"
        (click)="switchTo('privacy')"
      >
        Privacy Policy
      </button>

      
    </div>

  </div>
</div>